import { Document, DocumentType } from '../../plugins/api'
import { chunk, rangeRight } from 'lodash-es'

export default {
  namespaced: true,
  state: {
    documents: [],
    searchParams: {},
    totalItems: 0,
    itemsPerPage: 10,
    pageText: '',
    loading: false,
  },
  actions: {
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      state.loading = true
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.searchParams) {
        const searchParams = {
          ...state.searchParams,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
        }
        const [totalItems, documents] = await Promise.all([Document.count(searchParams), Document.search(searchParams)])

        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            documents,
            totalItems,
            itemsPerPage,
            searchParams,
          })

          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('changeState', pageText)
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      state.loading = false
    },
    async searchDocuments({ commit, state, dispatch }, query) {
      const searchParams = {
        _limit: state.itemsPerPage,
        ...query,
        _sort: 'createdAt:DESC',
      }

      commit('changeState', { searchParams })
      dispatch('requestPageSettings', {})
    },
    async createDocument(_, data) {
      const d = await Document.create(data)
      return d
    },
    async removeDocument({ commit }, id) {
      const d = await Document.remove(id)
      commit('removeDocument', d.id)
      return d
    },
    async fetchDocumentType(_, id) {
      const t = await DocumentType.fetchOne(id)
      return t
    },
    async removeDocuments(_, ids) {
      const groups = chunk(ids, 5)
      for (const subIds of groups) {
        const promises = subIds.map((id) => Document.remove(id))
        await Promise.all(promises)
      }
    },
    async fetchSchoolScheduleDocType() {
      const type = await DocumentType.fetch({ type: 'school-schedule', _limit: 1 })
      return type.length > 0 ? type[0] : {}
    },
    async fetchClassNoteDocType() {
      const type = await DocumentType.fetch({ type: 'class-note', _limit: 1 })
      return type.length > 0 ? type[0] : {}
    },
    async fetchTimeTableDocType() {
      const type = await DocumentType.fetch({ type: 'old-time-table', _limit: 1 })
      return type.length > 0 ? type[0] : {}
    },
    async fetchInspectionTimtableDocType() {
      const type = await DocumentType.fetch({ type: 'inspection-timetable', _limit: 1 })
      return type.length > 0 ? type[0] : {}
    },
  },
  mutations: {
    removeDocument(state, id) {
      state.documents = state.documents.filter((d) => d.id !== id)
    },
  },
}
